import { render, staticRenderFns } from "./previousExamPapers.vue?vue&type=template&id=310d491c&scoped=true&"
import script from "./previousExamPapers.vue?vue&type=script&lang=js&"
export * from "./previousExamPapers.vue?vue&type=script&lang=js&"
import style0 from "./previousExamPapers.vue?vue&type=style&index=0&id=310d491c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310d491c",
  null
  
)

export default component.exports